import { Action } from './action.model';
import { SkillAvailableDefinition } from './skill-available-definition.model';
import { Invitation } from './invitation.model';

export class ReactiveOptions {
    FormTagName: string;
}

export class ProactiveOptions {
    FormTagName: string;
    Invitation: Invitation;
    AgentAvailability: SkillAvailableDefinition;
    Actions: Action[];
}

export class ChatRule {
    DisableChatButton: boolean;
    TargetSkill: string;
    ReportingTag: string;
    Reactive: ReactiveOptions;
    Proactive: ProactiveOptions;
}
